'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { Skeleton } from '@eliadmin/core/src/components/ui/skeleton';
import { useCategoryFilterContext } from './lazy-category-provider';

export function CategoryFilterContextPlaceholder() {
  const { status, retry } = useCategoryFilterContext();

  if (status === 'ready') return null;

  if (status === 'error') {
    return (
      <div className="flex flex-col items-center gap-3 py-6 text-center text-sm text-muted-foreground">
        <span>Filtre sa nepodarilo načítať.</span>
        <Button type="button" variant="outline" onClick={retry}>
          Skúsiť znova
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4 py-2" aria-busy="true" aria-label="Načítavajú sa filtre">
      <Skeleton className="h-6 w-2/3" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-6 w-1/2" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-6 w-3/5" />
    </div>
  );
}
